import React from 'react'

function Button(props) {
  const {color, name, type_} = props
  return (
    <button type={type_} className={`${color} " text-white px-3 py-2 rounded-lg m-2 hover:trasition-color transition-in-out delay-200"`}>{name}</button>
  )
}

export default Button